import { useQuery } from '@tanstack/react-query';

import { getProjectOwnershipTransferByToken } from '@/features/projects/project-details/api/project-ownership-transfer';

interface UseGetProjectOwnershipTransferByTokenOptions {
  invitationToken: string;
  enabled?: boolean;
}

export function useGetProjectOwnershipTransferByToken({
  invitationToken,
  enabled = true,
}: UseGetProjectOwnershipTransferByTokenOptions) {
  return useQuery({
    queryKey: ['project-ownership-transfer-by-token', invitationToken],
    queryFn: () => getProjectOwnershipTransferByToken(invitationToken),
    enabled: enabled && !!invitationToken,
  });
}
